<nb-layout>
	<nb-layout-header fixed>
		<app-sales-header></app-sales-header>
	</nb-layout-header>
	
	<nb-layout-column>
		<div class="container">
			<router-outlet></router-outlet>
		</div>
	</nb-layout-column>
	<nb-layout-footer>
		<app-sales-footer></app-sales-footer>
	</nb-layout-footer>
</nb-layout>


